export default["__VITE_ASSET__CoIL3X4a__","__VITE_ASSET__BSUCkAFb__"];